import { render, staticRenderFns } from "./CardWidgetsModal.vue?vue&type=template&id=b7a3eb4c&"
import script from "./CardWidgetsModal.vue?vue&type=script&lang=js&"
export * from "./CardWidgetsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports